import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useChartEffectTickFormatter } from 'src/hooks/useEffectFormatter';
import { MonthYearDateFormatter } from 'src/utils/TickFormatters';
import { TOTAL_EFFECT_DEF } from 'src/utils/metricDefinitions';
import { useLTDataContext } from '../../contexts/LTDataContext';

const title = 'Total effect';

export const TotalEffectOTBox: React.FC = () => {
  const { effects, isError, isLoading } = useLTDataContext();
  const valueTickFormatter = useChartEffectTickFormatter();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return effects.monthly.map((x) => ({
      utcEpoch: x.utcEpoch,
      value: x.totalMediaEffect,
    }));
  }, [effects]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={MonthYearDateFormatter}
      yAxisFormatter={valueTickFormatter}
      isError={isError}
      isLoading={isLoading}
      infoText={TOTAL_EFFECT_DEF}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={valueTickFormatter}
          dateFormatter={MonthYearDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
